import DocumentDiff from "./DocumentDiff";

export default DocumentDiff